/* ============================================================
   Petronella's — Books mega-menu tab switcher.
   The ONLY bespoke nav script (Developer Handoff, Part 1):
   open/close/keyboard/outside-click all come from Dawn's native
   <details>/<summary> disclosure — this only swaps which tab panel
   is visible inside the Books mega.

   Server-render model (differs from the prototype's innerHTML rebuild):
   snippets/header-mega.liquid outputs the tab rail plus every tab's
   panel up front; each panel carries [data-panel="{index}"] and each
   tab button carries [data-i="{index}"]. We just toggle `hidden` +
   the `.on` active class. Wrap the Books mega in [data-mega-tabs].
   ============================================================ */
(function () {
  "use strict";

  function initMega(root) {
    var tabs = root.querySelectorAll(".mega__tab");
    var panels = root.querySelectorAll("[data-panel]");
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (t) {
        var on = Number(t.dataset.i) === index;
        t.classList.toggle("on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        p.hidden = Number(p.dataset.panel) !== index;
      });
    }

    tabs.forEach(function (t) {
      var index = Number(t.dataset.i);
      // click for touch/keyboard; mouseenter mirrors the prototype's hover-to-switch
      t.addEventListener("click", function (e) { e.preventDefault(); activate(index); });
      t.addEventListener("mouseenter", function () { activate(index); });
      t.addEventListener("focus", function () { activate(index); });
    });

    activate(0);
  }

  function init() {
    document.querySelectorAll("[data-mega-tabs]").forEach(initMega);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

/* ============================================================
   Keep the full-width mega panels flush with the header's bottom.
   .mega--nav is position:fixed with top: var(--pet-header-bottom).
   Dawn's header height varies (announcement bar + sticky-on-scroll),
   so measure the header's live bottom edge and feed the variable
   instead of hard-coding it. Runs on load / resize / scroll and
   whenever a mega opens.
   ============================================================ */
(function () {
  "use strict";

  function measure() {
    var el =
      document.querySelector("sticky-header") ||
      document.querySelector(".section-header") ||
      document.querySelector(".header-wrapper");
    if (!el) return;
    var bottom = Math.max(0, Math.round(el.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty("--pet-header-bottom", bottom + "px");

    // The util bar lives INSIDE the sticky header, so without this it would pin
    // to the top too. Publishing its height lets the CSS pull the sticky block
    // up by exactly that much, so the util bar scrolls away and only the nav
    // bar sticks — the concept's behaviour (.util scrolls, .site-header sticks).
    var util = document.querySelector(".util");
    var uh = util ? Math.round(util.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--pet-util-h", uh + "px");
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      measure();
    });
  }

  function bind() {
    measure();
    document.querySelectorAll(".mega-nav").forEach(function (d) {
      d.addEventListener("toggle", measure);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind, { once: true });
  } else {
    bind();
  }
  window.addEventListener("load", measure);
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("scroll", schedule, { passive: true });
  document.addEventListener("shopify:section:load", bind);
})();
